import React from "react";
import ProductCard from "web/react/components/product-card/react";
import { ProductDetails } from "web/react/components/product-card/react/emo";
import { ProductImage } from "web/react/emo/product-card";
import { ProductCardFactory } from "web/types/examples/product-card";
import { ProductLayoutSerializer, ProductPageAreaSerializer } from "web/types/serializers";

interface OutOfStockProductPageProps {
    productArea: ProductPageAreaSerializer;
    productLayout: ProductLayoutSerializer;
    helpCentreURLs?: string[];
    isOverlay?: boolean;
    parentRef?: React.RefObject<HTMLElement>;
}

const product = ProductCardFactory();

export function OutOfStockProductPage({}: // productArea,
// productLayout,
// helpCentreURLs,
// isOverlay = false,
// parentRef,
OutOfStockProductPageProps): React.ReactElement {
    return (
        <div style={{ width: "300px" }}>
            <ProductCard product={product}>
                <ProductImage />
                <ProductDetails />
            </ProductCard>
        </div>
    );
}
